import React, { Fragment } from 'react'

import Carousel from 'components/ui/Carousel/Carousel'
import ImageWithPlaceholderFallback from 'components/ui/ImageWithPlaceholderFallback/ImageWithPlaceholderFallback'
import Loader from 'components/loaders/Loader/Loader'
import UpchargePrice from 'components/UpchargePrice/UpchargePrice'

import s from './ProductImagesWithName.scss'


const renderPicture = (props) => (
  <ImageWithPlaceholderFallback
    w={270}
    mW={316}
    alt="product"
    {...props}
  />
)

const ProductImagesWithName = (props) => {
  const { img, productId, brand, name, upchargePrice, media, mediaCount } = props

  const carouselOptions = {
    arrows: false,
    dots: true,
    swipe: true,
    touchMove: true,
  }

  const mediaNode = media.length ? (
    <Carousel className={s.image} options={carouselOptions}>
      {
        media.slice(0, mediaCount).map(({ preview }, index) => renderPicture({ key: index, src: preview }))
      }
    </Carousel>
  ) : renderPicture({ key: productId, src: img, className: s.image })

  return (
    <Fragment>
      <div className={s.container}>
        <Loader className={s.loader} />
        {mediaNode}
      </div>
      <div className={s.title}>
        <span className={s.brand}>
          {brand}
          {
            Boolean(upchargePrice) && (
              <UpchargePrice className={s.upchargePrice} price={upchargePrice} />
            )
          }
        </span>
        <br />
        {name}
      </div>
    </Fragment>
  )
}

ProductImagesWithName.defaultProps = {
  media: [],
  mediaCount: 5, // this number is handpicked for carousel to look good
}


export default ProductImagesWithName
